import { render, staticRenderFns } from "./UniversalTable.vue?vue&type=template&id=196e639b"
import script from "./UniversalTable.vue?vue&type=script&lang=js"
export * from "./UniversalTable.vue?vue&type=script&lang=js"
import style0 from "./UniversalTable.vue?vue&type=style&index=0&id=196e639b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports